<template>
  <div class="Meeting">
    <div class="banner">
      <div class="banner_title">
        <h1>柏庭荟</h1>
        <p>BOTING LIVING CLUB</p>
      </div>
    </div>
    <div class="service_bd">
      <LeftNav
        title="柏庭荟"
        :list="list"
        @event1="change($event)"
       :newData="newData"
        bigTitle="BOTING LIVING CLUB"
        :key="changing"
      ></LeftNav>
      <div class="bd_right">
        <router-view></router-view>
        <!-- <partyItem1
          title="柏庭荟"
          :list="list"
          :newData="newData"
          v-if="newData == 0"
        ></partyItem1>
         <partyItem2
          title="柏庭荟"
          :list="list"
          :newData="newData"
          v-if="newData == 1"
        ></partyItem2>
         <partyItem3
          title="柏庭荟"
          :list="list"
          :newData="newData"
          v-if="newData == 2"
        ></partyItem3>
         <partyItem4
          title="柏庭荟"
          :list="list"
          :newData="newData"
          v-if="newData == 3"
        ></partyItem4>
         <partyItem5
          title="柏庭荟"
          :list="list"
          :newData="newData"
          v-if="newData == 4"
        ></partyItem5>
         <partyItem6
          title="柏庭荟"
          :list="list"
          :newData="newData"
          v-if="newData == 5"
        ></partyItem6>
         <partyItem7
          title="柏庭荟"
          :list="list"
          :newData="newData"
          v-if="newData == 6"
        ></partyItem7>
         <partyItem8
          title="柏庭荟"
          :list="list"
          :newData="newData"
          v-if="newData == 7"
        ></partyItem8>
         <partyItem9
          title="柏庭荟"
          :list="list"
          :newData="newData"
          v-if="newData == 8"
        ></partyItem9>
         <partyItem10
          title="柏庭荟"
          :list="list"
          :newData="newData"
          v-if="newData == 9"
        ></partyItem10>
         <partyItem11
          title="柏庭荟"
          :list="list"
          :newData="newData"
          v-if="newData == 10"
        ></partyItem11> -->
      </div>
    </div>
  </div>
</template>
  <script>
import LeftNav from "../components/leftNav.vue";

export default {
  name: "Meeting",
  data() {
    return {
      changing:0,
      list: [
        {
          title: "柏庭荟简介",
          small_title: "BOTING LIVING CLUB INTRODUCTION",
          hasTitle: "柏庭荟简介",
           option:'1'
        },
        {
          title: "运动俱乐部",
          hasTitle: "运动俱乐部",
          small_title: "PHOTOGRAPHY CLUB",
           option:'0.95'
        },
        {
          title: "文艺俱乐部",
          hasTitle: "文艺俱乐部",
           option:'0.92'
        },
        {
          title: "休闲俱乐部",
          hasTitle: "休闲俱乐部",
            option:'0.9'
        },
        {
          title: "健身俱乐部",
          hasTitle: "健身俱乐部",
            option:'0.85'
        },
        {
          title: "桌游俱乐部",
          hasTitle: "桌游俱乐部",
           option:'0.8'
        },
        {
          title: "声乐俱乐部",
          hasTitle: "声乐俱乐部",
           option:'0.75'
        },
        {
          title: "书画俱乐部",
          hasTitle: "书画俱乐部",
           option:'0.7'
        },
        {
          title: "外语俱乐部",
          hasTitle: "外语俱乐部",
           option:'0.6'
        },
        {
          title: "园艺俱乐部",
          hasTitle: "园艺俱乐部",
           option:'0.3'
        }
      ],
      newData: 0,
    };
  },
  methods: {
    change(data) {
      this.newData = data;
      this.changing+=1;

    },
  },
  mounted: function () {
    // this.$router.push({ path: "/Meeting/partyItem1" });
  },
  components: {
    LeftNav,
  },
  watch: {
    newData: {
      handler: function () {
        //do something

        if (this.newData == 0) {
          this.$router.push({ path: "/Meeting/partyItem1" });
        } else if (this.newData == 1&&window.location.href.indexOf("/Meeting/partyItem2")==-1) {
          this.$router.push({ path: "/Meeting/partyItem2" });
        } else if (this.newData == 2&&window.location.href.indexOf("/Meeting/partyItem3")==-1) {
          this.$router.push({ path: "/Meeting/partyItem3" });
        } else if (this.newData == 3&&window.location.href.indexOf("/Meeting/partyItem4")==-1) {
          this.$router.push({ path: "/Meeting/partyItem4" });
        } else if (this.newData == 4&&window.location.href.indexOf("/Meeting/partyItem5")==-1) {
          this.$router.push({ path: "/Meeting/partyItem5" });
        } else if (this.newData == 5&&window.location.href.indexOf("/Meeting/partyItem6")==-1) {
          this.$router.push({ path: "/Meeting/partyItem6" });
        } else if (this.newData == 6&&window.location.href.indexOf("/Meeting/partyItem7")==-1) {
          this.$router.push({ path: "/Meeting/partyItem7" });
        } else if (this.newData == 7&&window.location.href.indexOf("/Meeting/partyItem8")==-1) {
          this.$router.push({ path: "/Meeting/partyItem8" });
        } else if (this.newData == 8&&window.location.href.indexOf("/Meeting/partyItem9")==-1) {
          this.$router.push({ path: "/Meeting/partyItem9" });
        } else if (this.newData == 9&&window.location.href.indexOf("/Meeting/partyItem10")==-1) {
          this.$router.push({ path: "/Meeting/partyItem10" });
        } else if (this.newData == 10&&window.location.href.indexOf("/Meeting/partyItem11")==-1) {
          this.$router.push({ path: "/Meeting/partyItem11" });
        }
      },
      deep: true,
    },
    $route: {
      handler(newRouter) {
      
        if (newRouter.path == "/Meeting/partyItem1") {
          this.newData = 0;
        } else if (newRouter.path == "/Meeting/partyItem2") {
           this.newData = 1;
        }else if (newRouter.path == "/Meeting/partyItem3") {
           this.newData =2;
        }else if (newRouter.path == "/Meeting/partyItem4") {
           this.newData = 3;
        }else if (newRouter.path == "/Meeting/partyItem5") {
           this.newData = 4;
        }else if (newRouter.path == "/Meeting/partyItem6") {
           this.newData = 5;
        }else if (newRouter.path == "/Meeting/partyItem7") {
           this.newData = 6;
        }else if (newRouter.path == "/Meeting/partyItem8") {
           this.newData = 7;
        }else if (newRouter.path == "/Meeting/partyItem9") {
           this.newData = 8;
        }else if (newRouter.path == "/Meeting/partyItem10") {
           this.newData = 9;
        }else if (newRouter.path == "/Meeting/partyItem11") {
           this.newData = 10;
        }
        
      },
      immediate: true,
    },
  },
};
</script>
<style scoped="scoped">
.banner {
  width: 100%;
  height: 8.75rem;
  background-image: url("../assets/image/party/banner_2.png");
  background-size: 100% 100%;
  position: relative;
}
.banner_title {
  position: absolute;
  left: 2.5rem;
  bottom: 2.125rem;
  width: 5.6625rem;
  height: 2.6375rem;
  background-color: rgba(64, 104, 76, 0.5);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding-left: 0.4875rem;
}
.banner_title h1 {
  font-size: 0.65rem;
  font-family: PingFang SC;
  font-weight: 500;
  color: #ffffff;
}
.banner_title p {
  font-size: 0.4rem;
  font-family: Century Gothic;
  font-weight: 400;
  color: #ffffff;
}
.service_bd {
  padding: 0.75rem 2.5rem 0;
  display: flex;
  justify-content: space-between;
  padding-bottom: 7.225rem;
}
.bd_right {
  width: 12.6rem;
}
</style>